<template>
   <div>
      <!--======== Banner Home Section | Banner do cabeçalho da home  para seleção de cidade e data ========-->
      <section v-if="!isMobile" id="banner-home" class="d-none d-lg-block" :style="{ background: `url(${bgHome})` }">

         <b-container class="h-100 calendar-home-wrap p-4 pl-md-3 pr-md-3">
            <b-row class="h-100">
               <b-col md="8" lg="6">
                  <!--busca-->
                  <SearchBlock title="Aluguel de Bicicletas"/>
               </b-col>
<!--               <b-col md="4" lg="6" class="text-right">
                  <BadgeGooglePlay />
               </b-col>-->
            </b-row>
            <b-row class="h-100 mt-3">
               <b-col  md="8" lg="6">
                  <CtaAnfitriao />
               </b-col>
            </b-row>
         </b-container>
      </section>

      <section v-if="isMobile" class="banner-mobile bg-cover d-block d-lg-none position-relative" :style="{ background: `url(${bgHome})` }">
         <div style="z-index: 1" class="position-relative">
            <h1 class="h2 font-weight-bold text-white text-center">Bem vindo a Pedale</h1>
            <p style="font-weight: 500;" class="text-white text-center lead px-3">Digite a cidade aonde você quer pedalar:</p>
         </div>
         <div class="mask"></div>
         <b-container class="h-100 calendar-home-wrap">
            <b-row no-gutters class="h-100">
               <b-col md="12" lg="12" xl="5">
                  <!--busca-->
                  <SearchBlock inlineButton title="" subTitle=""/>

               </b-col>
            </b-row>
         </b-container>
      </section>

      <!--======== CTA Anfitrião ========-->
      <section class="banner-mobile d-block d-lg-none position-relative p-0 mb-2">
         <CtaAnfitriao :isMobile="true" />
      </section>

      <!--======== Selos marketing places ========-->
      <section v-if="!pushToken" class="banner-mobile d-block d-lg-none position-relative p-0 mt-0 mb-3 text-center">
<!-- <BadgeGooglePlay />-->
      </section>

      <!--======== Procurando bikes ========-->
      <div v-if="loading.bikes" class="bg-light2" style="text-align: center; padding: 3rem 3rem 1px">
         <i class="el-icon-loading h3"></i>
         <p class="lead">Procurando bicicletas próximas de você...</p>
      </div>

      <!--======== Bicicletas próximas ========-->
      <section v-if="bikes.length > 0"  id="most-rented-bikes" class="pt-0 pl-3 pr-3 pt-lg-4">
         <b-container class="wrap">
            <!--Card Bike | Card Bicicleta-->
            <b-row class="mt-3 justify-content-center">
               <b-col cols="12" class="text-center">
                  <h4 class="mb-3"><i class="el-icon-location"></i> Bicicletas próximas de você</h4>
               </b-col>
               <!-- eslint-disable -->
               <b-col cols="12" v-if="bike.user" md="6" lg="4" xl="4" class="mb-4 p-0 p-md-4 justify-content-center" v-for="(bike, index) in bikes"
                      :key="index">
                  <CardBike v-if="bike._id" :loading="loading.bikes"  :bike="bike" />
               </b-col>
            </b-row>
         </b-container>
      </section>

      <!--======== Entenda como funciona o Pedale ========-->
      <section class="pt-3 bg-light2 pt-5 pb-5">
         <b-container class="wrap">
            <b-row class="wrap-content-styled">
               <b-col cols="12" class="mb-4">
                  <h3 class="mb-3 font-weight-bold text-center mb-4">Alugar uma bicicleta é fácil, rápido e seguro</h3>
                  <p class="lead text-center">
                     Bem-vindo à nossa plataforma de aluguel de bicicletas, onde a mobilidade sustentável encontra a comodidade do compartilhamento. Aqui, estamos comprometidos em construir uma solução em mobilidade junto com os anfitriões locais, através de uma ferramenta fácil, rápida e segura.
                  </p>
               </b-col>
               <b-col class="text-center text-md-left" md="12" lg="6" xl="8">

                  <div class="text-justify text-muted">
                     <p>
                        Enquanto meio de transporte, a bicicleta permite que as pessoas se desloquem pelas cidades de forma eficiente, promovendo um estilo de vida ativo que melhora a saúde e a qualidade de vida. Ela também abre caminho para aventuras, viagens e exploração, conectando as pessoas com novas experiências e oportunidades de negócios, como o aluguel de bicicletas.
                     </p>


                     <p>
                        Se você é um ciclista experiente ou iniciante, um viajante em busca de novas experiências, ou alguém que deseja aproveitar todos os benefícios que uma bicicleta pode oferecer, você está no lugar certo.
                     </p>

                     <p>
                        Junte-se a nós e descubra como nossa plataforma pode conectar você a uma comunidade inteira de amantes de bicicletas, tudo enquanto promovemos um futuro mais saudável para todos. Pedale conosco e seja parte da revolução da mobilidade!
                     </p>
                     <img class="img-fluid text-center mb-4" :src="bgHowWorks" alt="banner">

                  </div>
               </b-col>

               <b-col class="text-center text-md-left mt-4 mt-lg-0" md="12" lg="6" xl="4">
                  <h5 class="text-center mb-3">Veja como alugar uma bicicleta no vídeo:</h5>

                  <iframe style="border-radius: 33px; border: 12px rgba(93, 98, 98, 0.14) solid;" class="d-block m-auto frame-video" width="350" height="600" src="https://www.youtube.com/embed/_SaUv4zUXes" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
               </b-col>
            </b-row>
         </b-container>
      </section>

      <!--======== CTA Anfitrião ========-->
      <CallToActionSection
         title="Quer ser anfitrião de bike na sua cidade?"
         desc="Depois de fazer o login na plataforma, você terá acesso ao cadastro da bike."
         textLink="Quero ser anfitrião(ã) de bike (CPF ou CNPJ)"
         link="/registrar"
         :bg="bgHome2"
      >

         <b-container class="wrap mt-5">
            <b-row>
               <b-col class="text-justify card-anfitriao" md="12" lg="6" xl="8">
                  <h5 class="text-white">Torne-se anfitrião (ã) de bicicleta e faça a diferença na sua cidade e no mundo.</h5>
                  <p class="mb-4" style="opacity: 0.9">
                     O compartilhamento remunerado da sua bike promove um futuro mais limpo e saudável para todos.
                     Junte-se a nós hoje e faça da sua bicicleta uma fonte de mudança positiva.
                  </p>
                  <h5 class="text-white">Porque Ser Anfitrião de Bicicleta? </h5>
                  <p class="mb-4" style="opacity: 0.9">
                     Ao ofertar a sua bicicleta para aluguel, você ajuda a reduzir o tráfego, a poluição e as emissões de carbono em sua cidade. Além disso, você cria conexões com viajantes e locais, promovendo um estilo de vida ativo e sustentável.
                     <strong>Sua bicicleta, seu impacto.</strong>
                     Inscreva-se agora e comece a pedalar rumo a um futuro melhor. <br>
                     Junte-se a nós na construção de uma solução em mobilidade sustentável!
                  </p>

                  <h5 class="text-white">Siga os Passos para Ser Anfitrião de Bike na Sua Cidade</h5>

                  <p class="mb-4" style="opacity: 0.9">
                     Primeiro, faça o login na plataforma. <br>
                     2. Quando estiver logado, complete as informações que faltaram, incluindo as "verificações". Seja um anfitrião nível ouro! <br>
                     3. Logo após, clique em "Painel do Anfitrião" + "minhas bicicletas" + "adicionar bicicleta" e siga os passo do cadastro, finalizando com as fotos da sua bike. <br>
                     Fotos bem iluminadas e detalhadas fazem toda a diferença!
                  </p>

                  <h5 class="text-white">Informações</h5>
                  <p class="mb-4" style="opacity: 0.9">
                     Combine a forma de pagamento com a pessoa que alugou a sua bike. Geralmente o pagamento acontece no momento da entrega.
                  </p>
                  <p class="mb-4" style="opacity: 0.9">Aproveite para informar como será a entrega da bike ou se a pessoa terá que buscar. Se essa informação estiver na descrição da bicicleta, melhor ainda.</p>

                  <h5 class="text-white">Dúvidas</h5>
                  <p class="font-weight-bold">Estamos prontos para esclarecer as suas dúvidas via <a target="_blank" title="Abrir Whatsapp" href="https://wa.me/5551983599666">WhatsApp</a>.</p>
               </b-col>
               <b-col class="text-center text-md-left mt-4 mt-lg-0 p-0" md="12" lg="6" xl="4">

                  <iframe style="border-radius: 10px" class="d-block m-auto frame-video" width="90%" height="770" src="https://www.youtube.com/embed/xiJDFzrTlxU?si=IlD8fcRp6kKTyjpo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
               </b-col>
            </b-row>
         </b-container>
      </CallToActionSection>

      <!--======== Segurança da Plataforma ========-->
      <section class="pt-3 pt-5 pb-5">
         <b-container class="wrap">
            <div class="text-center">
               <h3 class="mb-3 text-center mb-5 font-weight-bold">Segurança da Plataforma</h3>
            </div>
            <b-row>
               <b-col class="text-center text-md-left" md="12" lg="5">
                  <div class="text-justify">
                     <p>
                       <strong>O recurso que deixa os donos de bicicletas ainda mais tranquilos na hora de aceitar uma locação!</strong>
                     </p>

                     <p class="text-muted">
                        Quando o dono da bicicleta recebe uma reserva, ele consegue visualizar quais foram as verificações enviadas pelo ciclista e confirmadas pela Pedale.
                     </p>

                     <p class="text-muted">
                        Desde sempre, a Pedale valida todos os donos de bikes para dar segurança aos ciclistas. Agora é a vez dos ciclistas que, via plataforma, podem enviar informações e documentos para comprovar sua identidade e endereço, por exemplo.
                     </p>
                     <p class="text-muted">
                        Para os donos de bikes mais apegados a sua magrela, a Pedale disponibiliza ainda um seguro com cobertura para os casos de locação (necessário ter a nota fiscal da bicicleta), além das coberturas normais de qualquer seguro. Esse seguro deve ser contratado separadamente, 100% online e com apólice.
                     </p>
                  </div>
               </b-col>

               <b-col class="text-center text-md-left mt-4 mt-lg-0" md="12" lg="7">
                  <img class="img-fluid" :src="security" alt="Segurança">
                  <p class="text-center">Para solicitar uma cotação é só nos chamar no WhatsApp. </p>

                  <p class="text-center">Se você está pronto para disponibilizar a sua bicicleta, é só fazer  <router-link to="login">login</router-link> na plataforma para ter acesso ao cadastro da bike, qualquer esclarecimento, estamos à disposição! </p>
               </b-col>
            </b-row>
         </b-container>
      </section>

      <!--======== Blog ========-->
      <section id="blog-home" class="bg-light2 py-5">
         <b-container class="wrap">
            <p style="letter-spacing: 12px" class="text-center d-block mb-2 text-muted">BLOG</p>
            <h3 class="text-center mb-4">Últimos Artigos</h3>
            <carousel
               :scrollPerPage="false"
               :perPage="1"
               :perPageCustom="[[768, 3], [1024, 4]]"
               navigationEnabled
               autoplay
               :autoplayTimeout="4000"
               loop
               navigationNextLabel='<i class="el-icon-arrow-right"></i>'
               navigationPrevLabel='<i class="el-icon-arrow-left"></i>'
            >
               <slide
                  class="slider-wrap"
                  v-for="item in blog"
                  :key="item.id"
               >
                  <div class="card-blog">
                     <a :href="item.link" target="_blank"
                        class="feature-image"
                        :style="{backgroundImage : `url(${item._embedded['wp:featuredmedia'].map(v => v.media_details.sizes.thumbnail.source_url)})`}"
                        ></a>
                      <div class="content-blog">
                         <a :href="item.link" target="_blank">
                            <h3 class="h5 font-weight-bold mt-3 text-center">{{ item.title.rendered }}</h3>
                         </a>
                         <div class="text-primary d-flex justify-content-between">
                            <small class="d-block text-center"> <i class="el-icon-user mr-1"></i> {{item._embedded.author[0].name}}</small>
                            <small>●</small>
                            <small class="d-block text-center"> <i class="el-icon-date mr-1"></i> {{item.date | moment("DD/MM/YYYY")}}</small>
                         </div>
                         <div class="text-justify text-muted" v-html="item.excerpt.rendered"></div>
                         <a
                            target="_blank"
                            class="el-button pt-1 d-block pb-1 bg-transparent text-primary font-weight-bold el-button--primary is-round border-0"
                            :href="item.link">Leia mais
                         </a>
                      </div>
                  </div>
               </slide>
            </carousel>
            <div class="text-center">
               <a
                  target="_blank"
                  class="el-button pt-2 text-decoration-none mt-4 d-inline-block pb-2 bg-primary text-white font-weight-bold el-button--primary is-round"
                  href="https://pedale.net.br/blog">Visite o Blog da Pedale →
               </a>
            </div>
         </b-container>
      </section>
   </div>
</template>

<script>
// @ is an alias to /src
import bgHome from '@/assets/img/banner-home.jpg';
import bgHowWorks from '@/assets/img/entenda-como-funciona-pedale-img.svg';
import security from '@/assets/img/pedale-seguranca.jpg';
import bgHome2 from '@/assets/img/pexels-photo-1507510.jpg';
import CallToActionSection from "@/components/CallToActionSection";
import CardBike from "@/components/CardBike";
import CtaAnfitriao from "@/components/Ctas/CtaAnfitriao";
import SearchBlock from "@/components/SearchBlock";
import { metaTags } from "@/helpers";
import SiteService from '@/services/site.service';
import { Carousel, Slide } from 'vue-carousel';
export default {
   name: 'home',
   metaInfo: metaTags(),
   components: {
      SearchBlock,
      CallToActionSection,
      CardBike,
      CtaAnfitriao,
      Carousel,
      Slide,
   },
   data() {
      return {
         loading: {
            bikes: false
         },
         bgHome,
         bgHome2,
         bgHowWorks,
         security,
         bikes: [],
         latitude: 0,
         longitude: 0,
         pushToken: null,
         blog: [],
         isMobile: false
      }
   },
   async mounted() {
      this.loading.bikes = true

      // Pega a localização via navegador
      this.getLocation()

      // Usado para verificar se há coordenadas armazenadas no localStorage. Caso tenha, então busca as bikes próximas.
      const coord = JSON.parse(localStorage.getItem('coordenadas'))

      if (coord) {
         this.latitude = coord.latitude
         this.longitude = coord.longitude
         this.searchBikesV2(0, coord.longitude +  ',' + coord.latitude, null)
      }

      // Usado para ouvir eventos enviados via APP Pedale.
      window.addEventListener('message', this.handleAppMessage);

      // Usado para dar timeout no loading da procura das bikes.
      // Usado caso o GPS fica desligado
      setTimeout(() => {
         this.loading.bikes = false
      }, 10000)

      // Obtém a lista de artigos do blog
      await this.getBlogPosts()

      // Usado para detectar se a tela é mobile ou não.
      this.checkIsMobileClient()
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
   },
   beforeDestroy() {
      window.removeEventListener('message', this.handleAppMessage);
   },
   methods: {

      // Obtém a lista de artigos do blog da pedale
      async getBlogPosts() {
        const res =  await SiteService.getBlogPosts()
         this.blog = res.data
      },

      // Obtém a localização via navegador
      getLocation() {
         if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.setPosition);
         } else {
            alert("Seu sistema não suporta geolocalização!")
         }
      },

      // Armazenas as coordenadas obtidas pelo navegador
      setPosition(position) {
         this.latitude = position.coords.latitude
         this.longitude = position.coords.longitude

         this.searchBikesV2(0, position.coords.longitude +  ',' + position.coords.latitude, null)
      },

      // Assina evento enviado pelo APP.
      async handleAppMessage(event) {
         if (event.data && typeof event.data === 'object') {
            const message = event.data;

            // Salva o token do push no local storage
            if (event.data.pushToken) {
               localStorage.setItem('pushToken', JSON.stringify({
                  pushToken: event.data.pushToken
               }))
            }

            // Obtém a localização enviada via app, seta nas variáveis locais e no localStorage.
            if (event.data.latitude && event.data.longitude) {
               this.latitude = message.latitude;
               this.longitude = message.longitude;


               const storageLocation = JSON.parse(localStorage.getItem('coordenadas'))

               // Verifica se já contem localização no storage, caso não tenha, busca bikes e seta localStorage
               if (!storageLocation) {
                  this.loading.bikes = true
                  localStorage.setItem('coordenadas', JSON.stringify({
                     latitude: message.latitude,
                     longitude: message.longitude
                  }))

                  this.searchBikesV2(0, message.longitude +  ',' + message.latitude, null)
               }
            }
         }
      },

      searchBikesV2(city, coordinates, dates) {
         SiteService.searchBikes(city, coordinates, dates).then(
            response => {
               if (response.data.data.length) {
                  this.bikes = response.data.data
               }
               this.loading.bikes = false
            },
            err => {
               this.$message.error(err.response.data.message);
               this.loading.bikes = false
               this.$message.error(err.response.data.message);
            }
         );
      },

      checkIsMobileClient() {
         this.pushToken = JSON.parse(localStorage.getItem('pushToken'))
      },

      onResize () {
         this.isMobile = window.innerWidth < 992
      }

   },
   computed: {
      currentUser() {
         return (this.$store.state.auth.user ? this.$store.state.auth.user : null);
      }
   },

}
</script>

<style lang="scss">
.VueCarousel-pagination {display: none}
.VueCarousel {
   @media screen and (max-width: 1630px) {
      width: 90%;
      margin: auto;
   }
}
.slider-wrap {
   padding: 10px;

   button.VueCarousel-navigation-button {
      font-size: 30px;
      color: #4ab555 !important;
   }

   .card-blog {
      background-color: #fff;
      border-radius: 10px;
   }

   .content-blog {
      padding: 0px 15px 20px;
   }

   &:hover .feature-image {
      &:after {
         background-color: rgba(71, 181, 76, 0.4);
         transition: all 300ms ease;
         color: #fff;
      }

   }

   .feature-image {
      border-radius: 10px 10px 0 0 ;
      height: 160px;
      width: 100%;
      display: block;
      background-position: center;
      background-size: cover;
      transition: all 300ms ease;
      position: relative;
      overflow: hidden;

      &:after {
         transition: all 300ms ease;
         position: absolute;
         width: 100%;
         height: 100%;
         background: transparent;
         text-align: center;
         font-size: 50px;
         content: "\e6ce";
         font-family: 'element-icons' !important;
         color: transparent;
         padding: 45px 0;
      }
   }

   a {
      text-decoration: none;
   }

   h3 {
      color: black;
      font-size: 1.2rem;
      transition: all 300ms ease;
      &:hover {
         color: #47b54c;
      }
   }

   small {
      margin-bottom: 10px;
   }
   p {
      font-size: 0.9rem;
   }
}

.wrap-content-styled {
   border-radius: 20px;
   background: #fff !important;
   padding: 40px 25px;
   margin: 0;

   @media screen and (max-width: 768px) {
      padding: 25px 10px;
   }
}

@media screen and (max-width: 768px) {
   #blog-home {
    overflow: hidden;
   }
   .frame-video {
      width: 100%;
   }
   .card-anfitriao {
      padding: 15px !important;
   }
}

.card-anfitriao {
   background-color: rgba(91,96,97, 0.83);
   border-radius: 10px;
   padding: 20px 30px;
}


.fade-in-image {
   opacity: 0;
   animation: fadeIn 1s ease 1s forwards;
   -webkit-animation: fadeIn 1s ease 1s forwards;
   -moz-animation: fadeIn 1s ease 1s forwards;
   -o-animation: fadeIn 1s ease 1s forwards;
   -ms-animation: fadeIn 1s ease 1sforwards ;
}
@keyframes fadeIn {
   0% { opacity: 0; }
   100% { opacity: 1; }
}
</style>
